import React from 'react';
import PropTypes from 'prop-types';

const RecommendationFooter = ({ url, buttonText, mixPanelContext, mixPanelType }) => {
	return (
		<div className="re-recommendation-btn">
			<a
				href={url}
				className="re-btn re-btn-full-width"
				data-mixpanel-name="Intent"
				data-mixpanel-context={mixPanelContext}
				data-mixpanel-type={mixPanelType}
			>
				{buttonText}
			</a>
		</div>
	);
};

RecommendationFooter.propTypes = {
	url: PropTypes.string.isRequired,
	buttonText: PropTypes.string.isRequired,
	mixPanelType: PropTypes.string.isRequired,
	mixPanelContext: PropTypes.string.isRequired
};

export default RecommendationFooter;
